module.exports = {
  context: {
    stories: [
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Ava Green'
        },
        heading: 'Ava Green',
        shortDescription: 'Senior Director<br />Fresno, CA',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'John Taylor'
        },
        heading: 'John Taylor',
        shortDescription: 'Navy Veteran<br />San Diego, CA',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Nora James'
        },
        heading: 'Nora James',
        shortDescription: 'Human Resources Specialist<br />Fresno, CA',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Marcy Miller'
        },
        heading: 'Marcy Miller',
        shortDescription: 'Fresno, CA',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Anna Demarco'
        },
        heading: 'Anna Demarco',
        shortDescription: 'Vice President<br />West Hollywood, CA',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/ava-green.jpg?mtime=20210622121530&focal=none',
          alt: 'Max Smith'
        },
        heading: 'Max Smith',
        shortDescription: 'Army Veteran<br />Encinitas, CA',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      }
    ]
  }
}
